import React from 'react'
import { useAppSelector } from 'src/app/hooks'
import * as steps from './steps'

const MassiveCalculationStepSwitch = () => {
  const { step: currentStep } = useAppSelector((state) => state.admin.massiveCalculation)

  return (
    <>
      {currentStep === 0 && <steps.ImportTransactionStep />}
      {currentStep === 1 && <steps.SelectFieldsStep />}
      {currentStep === 2 && <steps.ConfirmTransactionStep />}
      {currentStep === 3 && <steps.DownloadCertificatesStep />}
    </>
  )
}

export default MassiveCalculationStepSwitch
